import { Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import CapitalFundingPage from "@/pages/CapitalFundingPage";
import FmcgPage from "@/pages/FmcgPage";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/capital-funding" element={<CapitalFundingPage />} />
          <Route path="/fmcg" element={<FmcgPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A1F44",
            color: "#fff",
            border: "1px solid rgba(200,162,74,0.4)",
          },
        }}
      />
    </div>
  );
}

export default App;
